export const setFields = (fields) => {
    return {
        type: 'SET_FIELDS',
        payload: fields,
    };
}
